(() => {
  function init(root) {
    if (root.dataset.hdsReady) return;
    root.dataset.hdsReady = 'true';
    const content = root.querySelector('[data-hds-content]');
    const nav = root.querySelector('[data-hds-toc]');
    const headings = [...root.querySelectorAll(content ? '[data-hds-content] h2' : '.hds-topic')];
    if (content && nav && headings.length) {
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `hds-section-${index + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        nav.append(link);
        if (/quick overview/i.test(heading.textContent)) heading.nextElementSibling?.querySelector('table')?.classList.add('hds-overview');
      });
      root.querySelector('[data-hds-sidebar]').hidden = false;
    }
    const disclosure = root.querySelector('.hds-toc');
    if (disclosure) {
      const compact = matchMedia('(max-width: 777px)');
      const sync = () => { disclosure.open = !compact.matches; };
      sync(); compact.addEventListener('change', sync);
      disclosure.addEventListener('toggle', () => { if (!compact.matches && !disclosure.open) disclosure.open = true; });
    }
    if (nav) {
      const links = [...nav.querySelectorAll('a')];
      const update = () => {
        const offset = (parseFloat(getComputedStyle(document.body).getPropertyValue('--headerHeight')) || 70) + 55;
        let current = headings[0];
        headings.forEach(h => { if (h.getBoundingClientRect().top <= offset) current = h; });
        links.forEach(a => { if (current && a.hash === `#${current.id}`) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); });
      };
      let queued = false;
      window.addEventListener('scroll', () => { if (queued) return; queued = true; requestAnimationFrame(() => { update(); queued = false; }); }, { passive: true });
      nav.addEventListener('click', event => {
        const link = event.target.closest('a');
        if (!link || !link.hash) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        if (matchMedia('(max-width: 777px)').matches) disclosure.open = false;
        history.replaceState(null, '', link.hash);
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
        update();
      });
      update();
      if (location.hash.startsWith('#hds-')) {
        const target = document.getElementById(location.hash.slice(1));
        if (target && root.contains(target)) requestAnimationFrame(() => target.scrollIntoView({ behavior: 'instant', block: 'start' }));
      }
    }
    if (root.dataset.serviceKind === 'tracking') {
      const app = root.querySelector('.hds-tracking-app');
      const labelInputs = () => {
        app.querySelectorAll('.track123_tab_bar').forEach(tab => {
          tab.setAttribute('role', 'button');
          tab.setAttribute('tabindex', '0');
          tab.setAttribute('aria-pressed', String(tab.classList.contains('track123_tab_bar_color')));
        });
        app.querySelectorAll('.track123_input_container').forEach((container, i) => {
        const input = container.querySelector('input'), label = container.querySelector('.track123_form_label'), error = container.querySelector('.track123_form_error');
        if (!input || !label) return;
        if (!label.id) label.id = `hds-track-label-${i}`;
        input.setAttribute('aria-labelledby', label.id);
        if (error) { if (!error.id) error.id = `hds-track-error-${i}`; input.setAttribute('aria-describedby', error.id); error.setAttribute('role', 'alert'); }
        });
      };
      app.addEventListener('keydown', event => {
        const tab = event.target.closest('.track123_tab_bar');
        if (tab && (event.key === 'Enter' || event.key === ' ')) { event.preventDefault(); tab.click(); }
      });
      labelInputs();
      const observer = new MutationObserver(labelInputs);
      observer.observe(app, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  const boot = () => document.querySelectorAll('[data-hdk-service]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
